import React, { Component } from 'react';
import Swal from 'sweetalert2';
import instance from "./axios-instance";
import MainSettingContext from './MainSettingContext';
import Systems from "./SystemFunction";
import jwt_decode from "jwt-decode";
import md5 from "md5";
import { t } from './i18n';

class App extends Component {
    static contextType = MainSettingContext;

    constructor(props) {
        super(props);
        this.state = {
            tabselect: 1,
            memberSubTab: 1,
            timeRange: "all",
            stats: { todaySignups: 0, thisMonthSignups: 0, lastMonthSignups: 0, totalSignups: 0, percentChange: "0.00" },
            reports: { daily: { totalAmount: 0 }, thisMonth: { totalAmount: 0 }, lastMonth: { totalAmount: 0 }, percentageChange: "0.00" },
            userafftoday: [],
            useradvicelist: [],
            pagecount: 1,
            activePage: 1,
            loading: false,
            tblprofile: props.tblprofile || {},
            userid: props.userid || null,
            linkaff: props.linkaff || "",
            loginstate: props.loginstate || false,
            username: props.username || "",
            balance: props.balance || 0,
            point: props.point || 0,
            rankpic: props.rankpic || "1.jpeg",
            rankname: props.rankname || null,
            rankob: props.rankob || null,
            rankpoint: props.rankpoint || 0,
            linelink: props.linelink || "",
        };
    }

    get lang() {
        return this.props.language || this.context?.language || localStorage.getItem('lang') || 'th';
    }

    maskUsername(name) {
        if (!name) return "***";
        if (name.length <= 4) return name[0] + "***";
        return name.substring(0, 3) + "***" + name.slice(-2);
    }

    async componentDidMount() {
        if (this.props.linelink) {
            this.setState({ linelink: this.props.linelink });
        } else {
            const data = this.context;
            if (data?.message) this.setState({ linelink: data.message[1].value });
        }

        if (this.props.loginstate && this.props.username) {
            const space = window.location.host;
            const userhash = md5(this.props.username);
            const computedLinkaff = this.props.linkaff || ("https://" + space + "/register?reg=" + userhash);
            this.setState({
                loginstate: this.props.loginstate,
                username: this.props.username,
                userid: this.props.userid,
                balance: this.props.balance,
                point: this.props.point,
                tblprofile: this.props.tblprofile,
                rankpic: this.props.rankpic,
                rankname: this.props.rankname,
                rankob: this.props.rankob,
                rankpoint: this.props.rankpoint,
                linkaff: computedLinkaff,
            });
            await this.checkuseradvice(this.props.username);
        } else {
            try {
                var token = localStorage.getItem('auth_token');
                if (token != null) {
                    var decoded = jwt_decode(token);
                    var Username = decoded.message.playerid;
                    const space = window.location.host;
                    const userhash = md5(Username);
                    this.setState({ linkaff: "https://" + space + "/register?reg=" + userhash });
                    await this.rechecklogin(Username, token);
                    await this.checkuseradvice(Username);
                    this.setState({
                        userid: decoded.message.playerid,
                        username: decoded.message.playerid,
                        loginstate: true,
                    });
                } else {
                    this.setState({ loginstate: false });
                }
            } catch (error) {}
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.loginstate !== this.props.loginstate ||
            prevProps.balance !== this.props.balance ||
            prevProps.point !== this.props.point ||
            prevProps.tblprofile !== this.props.tblprofile ||
            prevProps.linkaff !== this.props.linkaff
        ) {
            if (this.props.loginstate && this.props.username) {
                this.setState({
                    loginstate: this.props.loginstate,
                    username: this.props.username,
                    userid: this.props.userid,
                    balance: this.props.balance,
                    point: this.props.point,
                    tblprofile: this.props.tblprofile,
                    rankpic: this.props.rankpic,
                    rankname: this.props.rankname,
                    rankob: this.props.rankob,
                    rankpoint: this.props.rankpoint,
                    linkaff: this.props.linkaff,
                    linelink: this.props.linelink || this.state.linelink,
                });
            }
        }
    }

    async checkuseradvice(username, timeRange = "today", page = 1) {
        const User_id = username || this.state.username;
        if (!User_id) return;
        this.setState({ loading: true });
        try {
            const res = await instance.post("/api/v1/checkuseradvice", {
                User_id,
                page,
                System: Systems,
                timeRange,
            });
            if (res.data.status === 200 || res.data.status === 201) {
                const m = res.data.message;
                this.setState({
                    stats: m.stats || this.state.stats,
                    reports: m.reports || this.state.reports,
                    userafftoday: m.userafftoday || [],
                    useradvicelist: m.useradvicelist || [],
                    pagecount: m.pagecount || 1,
                    activePage: page,
                    loading: false,
                });
            } else {
                this.setState({ loading: false });
            }
        } catch (e) {
            this.setState({ loading: false });
        }
    }

    handleTimeRangeChange(newRange) {
        this.setState({ timeRange: newRange });
        this.checkuseradvice(this.state.username, newRange, 1);
    }

    handlePageChange(page) {
        this.checkuseradvice(this.state.username, this.state.timeRange, page);
    }

    checktab(e, index) {
        this.setState({ tabselect: index });
    }

    async rechecklogin(Username, token) {
        try {
            const space = window.location.host;
            var userhash = md5(Username);
            const linkaff = "https://" + space + "/register?reg=" + userhash;
            instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'rechecklogin-navbar.js',
            }, {
                headers: { Authorization: `Bearer ${token}` },
            }).then(async (res) => {
                if (res.data.status === 200) {
                    localStorage.setItem('auth_token', res.data.token);
                    this.setState({
                        rankpic: res.data.tblrank.image,
                        rankname: res.data.tblrank.name,
                        linkaff: linkaff,
                        rankob: res.data.tblrank,
                        rankpoint: res.data.rankpoint,
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        tblprofile: res.data.message,
                        username: res.data.message.playerid,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        loginstate: true,
                    });
                } else if (res.data.status === 401) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: t(this.lang, 'session_expired'),
                        icon: 'warning',
                        confirmButtonText: t(this.lang, 'ok'),
                    });
                    window.location.href = '/';
                }
            }).catch(async (err) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: t(this.lang, 'session_expired'),
                        icon: 'warning',
                        confirmButtonText: t(this.lang, 'ok'),
                    });
                    window.location.href = '/';
                }
            });
        } catch (ex) {}
    }

    async opencliaminvite(evt, cityName) {
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        await instance.post("/api/v1/cliaminvite", {
            userid: Username,
            System: Systems,
        }, {
            headers: { Authorization: `Bearer ${token}` },
        }).then(async (res) => {
            if (res.data.status === 200) {
                var decoded = jwt_decode(token);
                var Username = decoded.message.playerid;
                this.rechecklogin(Username, token);
                await Swal.fire({
                    title: 'Success!',
                    text: t(this.lang, 'aff_claim_success'),
                    icon: 'success',
                    confirmButtonText: t(this.lang, 'ok'),
                });
            } else if (res.data.status === 201) {
                await Swal.fire({
                    title: 'error!',
                    text: t(this.lang, 'aff_no_balance'),
                    icon: 'error',
                    confirmButtonText: t(this.lang, 'ok'),
                });
                return false;
            } else if (res.data.status === 202) {
                await Swal.fire({
                    title: 'error!',
                    text: t(this.lang, 'aff_claim_failed'),
                    icon: 'error',
                    confirmButtonText: t(this.lang, 'ok'),
                });
                return false;
            }
        }).catch(async (err) => {
            if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                localStorage.clear();
                await Swal.fire({
                    title: 'Warning!',
                    text: t(this.lang, 'session_expired'),
                    icon: 'warning',
                    confirmButtonText: t(this.lang, 'ok'),
                });
                window.location.href = '/';
            }
        });
    }

    copyLink() {
        const { linkaff } = this.state;
        if (!linkaff) return;
        if (navigator.clipboard) {
            navigator.clipboard.writeText(linkaff);
        } else {
            const el = document.createElement('textarea');
            el.value = linkaff;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        }
        Swal.fire({ title: t(this.lang, 'copied'), text: linkaff, icon: 'success', confirmButtonText: t(this.lang, 'ok'), timer: 1500 });
    }

    renderFilterButtons(activeRange) {
        const lang = this.lang;
        const filters = [
            { label: t(lang, 'today'), value: 'today' },
            { label: t(lang, 'seven_days_filter'), value: 'last7days' },
            { label: t(lang, 'month_filter'), value: 'lastMonth' },
            { label: t(lang, 'all_type'), value: 'all' },
        ];
        return (
            <div className="d-flex justify-content-between scroll-title-history-aff align-items-center mb-1 mt-1">
                {filters.map((f) => (
                    <div key={f.value}>
                        <a
                            className={`btn btn-outline-secondary text_aff_affiliate_tab${activeRange === f.value ? ' text_aff_affiliate_tab_active' : ''}`}
                            role="button"
                            onClick={() => this.handleTimeRangeChange(f.value)}
                        >
                            {f.label}
                        </a>
                    </div>
                ))}
            </div>
        );
    }

    renderTab1() {
        const lang = this.props.language || this.context?.language || 'th';
        const { linkaff, tblprofile, stats, reports } = this.state;
        const affiliateCash = tblprofile?.AffiliateCash ?? 0;
        return (
            <div className="mb-5 mt-2" style={{ display: this.state.tabselect === 1 ? "" : "none" }}>
                <div className="p-2 bg-profile-box-overview">
                    <div className="animated animatedFadeInUp fadeInUp mt-2">
                        {/* Income overview banner */}
                        <div className="bg-profile-box-overview p-2">
                            <div className="d-flex justify-content-between row m-0 align-items-center">
                                <div className="col-12 col-md-12 p-0">
                                    <div className="d-flex justify-content-between elementor-element-play-overview text-center bg-profile-credit-bl p-2">
                                        <div className="align-self-center">
                                            <div className="p-1 text-left">
                                                <div>
                                                    <h3 className="m-0">
                                                        <b className="p-1">{Number(reports.daily.totalAmount || 0).toFixed(2)}</b>
                                                    </h3>
                                                </div>
                                                <small>{t(lang, 'today_income')} / {t(lang, 'total_income')} : {Number(reports.thisMonth.totalAmount || 0).toFixed(2)}</small>
                                            </div>
                                        </div>
                                        <div className="align-self-center text-right">
                                            <div>
                                                <span className="badge text-bg-dark">
                                                    {reports.percentageChange || "0.00"}%
                                                </span>
                                            </div>
                                            <div>
                                                <span className="font-play-text">{t(lang, 'from_last_month')}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Affiliate link */}
                        <div className="mt-2 animated animatedFadeInUp fadeInUp">
                            <div className="mt-2 mb-2">
                                <img
                                    className="icon-profile-title-left"
                                    src="/images/cdn/81deef6a-eb5d-4bf2-221c-3b85586ca700.png"
                                    alt=""
                                />
                                <small className="pt-2 pb-2"><b>&nbsp; {t(lang, 'invite_link')}</b></small>
                            </div>
                            <div className="bg-color-financial-my-bank bg-profile-box-overview">
                                <div className="d-flex justify-content-between pt-3 pb-3">
                                    <div>
                                        <small>{t(lang, 'copy')}</small>
                                    </div>
                                    <div>
                                        <small className="font-play-text">
                                            <b>
                                                <small id="copy-ShareLink">{linkaff}</small>
                                                <img
                                                    role="button"
                                                    className="icon-profile-title-left"
                                                    src="/images/cdn/270b7b9f-b130-414c-b2a8-dfe9ecb9cc00.png"
                                                    alt=""
                                                    onClick={() => this.copyLink()}
                                                />
                                            </b>
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Withdraw income button */}
                        <div className="pt-2">
                            <div className="row m-0">
                                <div className="col-12 col-md-12 p-1">
                                    <div className="elementor-element-play-overview p-2">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <div className="d-flex align-items-center">
                                                <img
                                                    className="logo-profile-user-w p-1"
                                                    src="/images/cdn/48a22d9a-8abe-477f-0f40-57204ce17700.png"
                                                    alt=""
                                                />
                                                <div className="ms-1">
                                                    <small className="text_aff_affiliate">{t(lang, 'withdrawable_income')}</small>
                                                    <div><b className="font-aff-wid" style={{ fontSize: "1.2rem" }}>{affiliateCash}</b> <small className="text_aff_affiliate">{t(lang, 'baht')}</small></div>
                                                </div>
                                            </div>
                                        </div>
                                        <a role="button" onClick={(e) => { this.opencliaminvite(e, 'bonusrankaccount'); }} style={{ display: "block" }}>
                                            <div className="btn w-100 p-3" style={{ background: "linear-gradient(135deg,#f6a200,#e67e00)", color: "#fff", fontWeight: "bold", fontSize: "1rem", borderRadius: "8px" }}>
                                                <img
                                                    className="wid-button p-1"
                                                    src="/images/cdn/de26db72-10a7-4369-5e7e-dd07d4568300.png"
                                                    alt=""
                                                />
                                                {t(lang, 'withdraw_btn')}
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            {/* Stats cards */}
                            <div className="row m-0 mt-2">
                                <div className="col-6 p-0">
                                    <div className="elementor-element-play-overview p-2 m-1">
                                        <div className="d-flex justify-content-between text-center">
                                            <div className="align-self-center">
                                                <div className="p-1 text-left">
                                                    <img
                                                        className="icon-aff"
                                                        src="/images/cdn/5e4ede40-9f30-4c50-5278-136b8e2e0900.png"
                                                        alt=""
                                                    />
                                                    <div>
                                                        <h3 className="m-0"><b>{stats.totalSignups || 0}</b></h3>
                                                    </div>
                                                    <small role="button">{t(lang, 'member_count')}</small>
                                                </div>
                                            </div>
                                            <div className="align-self-center text-right">
                                                <div>
                                                    <div><small className="font-play-text">{t(lang, 'from_last_month')}</small></div>
                                                    <span className="badge text-bg-dark">{stats.percentChange || "0.00"}%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6 p-0">
                                    <div className="elementor-element-play-overview p-2 m-1">
                                        <div className="d-flex justify-content-between text-center">
                                            <div className="align-self-center">
                                                <div className="p-1 text-left">
                                                    <img
                                                        className="icon-aff"
                                                        src="/images/cdn/a7961b16-c14d-495f-3d2f-c7ea12ab2c00.png"
                                                        alt=""
                                                    />
                                                    <div>
                                                        <h3 className="m-0"><b>{stats.thisMonthSignups || 0}</b></h3>
                                                    </div>
                                                    <small role="button">{t(lang, 'members_this_month')}</small>
                                                </div>
                                            </div>
                                            <div className="align-self-center text-right">
                                                <div>
                                                    <div><small className="font-play-text">{t(lang, 'from_last_month')}</small></div>
                                                    <span className="badge text-bg-dark">{stats.percentChange || "0.00"}%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Quick links */}
                            <div className="d-flex justify-content-between pt-2 pb-2">
                                <div role="button" className="align-self-center">
                                    <img
                                        className="icon-profile-title-left"
                                        src="/images/cdn/f8270235-43e5-4c38-247d-98b9ebfbe700.png"
                                        alt=""
                                    />
                                    <small><b>&nbsp;{t(lang, 'new_members_today')}</b></small>
                                </div>
                                <div className="align-self-center">{stats.todaySignups || 0} {t(lang, 'person_unit')}</div>
                            </div>
                            <hr className="m-0 color-hr" />
                            <div className="d-flex justify-content-between pt-2 pb-2">
                                <div role="button" className="align-self-center" onClick={(e) => { this.checktab(e, 2); }}>
                                    <img
                                        className="icon-profile-title-left"
                                        src="/images/cdn/f8270235-43e5-4c38-247d-98b9ebfbe700.png"
                                        alt=""
                                    />
                                    <small><b>&nbsp;{t(lang, 'history_title')}</b></small>
                                </div>
                                <div className="align-self-center" onClick={(e) => { this.checktab(e, 2); }}>
                                    <img
                                        className="goto-financial"
                                        role="button"
                                        src="/images/cdn/ad650691-9c48-4cb9-6e44-36d5d1eaf700.png"
                                        alt=""
                                    />
                                </div>
                            </div>
                            <hr className="m-0 color-hr" />
                            <div className="d-flex justify-content-between pt-2 pb-2">
                                <div role="button" className="align-self-center" onClick={(e) => { this.checktab(e, 4); }}>
                                    <img
                                        className="icon-profile-title-left"
                                        src="/images/cdn/f8270235-43e5-4c38-247d-98b9ebfbe700.png"
                                        alt=""
                                    />
                                    <small><b>&nbsp;{t(lang, 'how_to_build_network')}</b></small>
                                </div>
                                <div className="align-self-center" onClick={(e) => { this.checktab(e, 4); }}>
                                    <img
                                        className="goto-financial"
                                        role="button"
                                        src="/images/cdn/ad650691-9c48-4cb9-6e44-36d5d1eaf700.png"
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderTab2() {
        const lang = this.lang;
        const { memberSubTab, timeRange, stats, userafftoday, useradvicelist, loading, activePage, pagecount } = this.state;
        return (
            <div className="mb-5 mt-2" style={{ display: this.state.tabselect === 2 ? "" : "none" }}>
                <div className="p-2 bg-profile-box-overview">
                    <div className="animated animatedFadeInUp fadeInUp">
                        {/* Sub-tab selector */}
                        <div className="d-flex justify-content-start mb-2">
                            <a
                                role="button"
                                className={`btn btn-sm btn-outline-secondary me-2 text_aff_affiliate_tab${memberSubTab === 1 ? ' text_aff_affiliate_tab_active' : ''}`}
                                onClick={() => this.setState({ memberSubTab: 1 })}
                            >
                                {t(lang, 'new_member_tab')}
                            </a>
                            <a
                                role="button"
                                className={`btn btn-sm btn-outline-secondary text_aff_affiliate_tab${memberSubTab === 2 ? ' text_aff_affiliate_tab_active' : ''}`}
                                onClick={() => this.setState({ memberSubTab: 2 })}
                            >
                                {t(lang, 'history_all_tab')}
                            </a>
                        </div>

                        {/* Filter buttons */}
                        {this.renderFilterButtons(timeRange)}

                        {/* Stats summary */}
                        <div className="bg-profile-box-overview p-2 mb-2">
                            <div className="d-flex justify-content-between row m-0 align-items-center">
                                <div className="col-12 col-md-12 p-0">
                                    <div className="d-flex justify-content-between elementor-element-play-overview text-center bg-profile-credit-bl p-2">
                                        <div className="align-self-center">
                                            <div className="p-1 text-left">
                                                <small>
                                                    <img
                                                        className="icon-aff"
                                                        src="/images/cdn/84f8435d-3a19-4e45-eb3c-57f582263300.png"
                                                        alt=""
                                                    />{" "}
                                                    {t(lang, 'active_total')}
                                                </small>
                                                <div>
                                                    <label className="m-0 font-member-aff-all">
                                                        <b className="p-1">{stats.totalSignups || 0}</b>
                                                    </label>{" "}{t(lang, 'person_unit')}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="align-self-center text-right">
                                            <div>
                                                <span className="badge text-bg-dark">{stats.percentChange || "0.00"}%</span>
                                            </div>
                                            <div>
                                                <span className="font-play-text text_aff_affiliate">{t(lang, 'from_last_month')}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row m-0 mt-1">
                                <div className="col-4 text-center">
                                    <small className="text_aff_affiliate">{t(lang, 'today')}</small>
                                    <div><b className="font-member-aff">{stats.todaySignups || 0}</b> <small className="text_aff_affiliate">{t(lang, 'person_unit')}</small></div>
                                </div>
                                <div className="col-4 text-center">
                                    <small className="text_aff_affiliate">{t(lang, 'this_month')}</small>
                                    <div><b className="font-member-aff">{stats.thisMonthSignups || 0}</b> <small className="text_aff_affiliate">{t(lang, 'person_unit')}</small></div>
                                </div>
                                <div className="col-4 text-center">
                                    <small className="text_aff_affiliate">{t(lang, 'all_type')}</small>
                                    <div><b className="font-member-aff">{stats.totalSignups || 0}</b> <small className="text_aff_affiliate">{t(lang, 'person_unit')}</small></div>
                                </div>
                            </div>
                        </div>

                        {/* Total member count card */}
                        <div className="row m-0">
                            <div className="col-12 col-md-6 p-1">
                                <div className="elementor-element-play-overview p-2">
                                    <div className="d-flex justify-content-between text-center">
                                        <div className="align-self-center">
                                            <div className="p-1 text-left">
                                                <img
                                                    className="icon-aff"
                                                    src="/images/cdn/57836a6a-99c5-4a6f-cad8-32de65521a00.png"
                                                    alt=""
                                                />{" "}
                                                {t(lang, 'all_members')}
                                                <div>
                                                    <b className="m-0 font-member-aff">{useradvicelist.length}</b>
                                                    <small className="text_aff_affiliate"> {t(lang, 'person_unit')}</small>
                                                </div>
                                                <small className="text_aff_affiliate">{t(lang, 'total_referred')}</small>
                                            </div>
                                        </div>
                                        <div className="align-self-center text-right">
                                            <div>
                                                <div><small className="font-play-text text_aff_affiliate">{t(lang, 'from_last_month')}</small></div>
                                                <span className="badge text-bg-dark">{stats.percentChange || "0.00"}%</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Sub-tab content */}
                        {memberSubTab === 1 && (
                            <div className="bg-profile-box-overview p-2 mb-2 mt-2">
                                <div className="d-flex justify-content-between pb-1">
                                    <small><b>{t(lang, 'new_member_tab')}</b></small>
                                </div>
                                {loading ? (
                                    <div className="text-center p-3">
                                        <span className="text_aff_affiliate">{t(lang, 'loading')}</span>
                                    </div>
                                ) : userafftoday.length === 0 ? (
                                    <div className="bg-profile-box-overview p-2 text-center animated animatedFadeInUp fadeInUp">
                                        <img
                                            className="load-history"
                                            src="/images/cdn/e4ac87bf-3687-4f37-c96e-6ad9e797bf00.png"
                                            alt=""
                                        />
                                        <div className="not-history font-history-menu-text p-2">
                                            <small><b>{t(lang, 'no_data')}</b></small>
                                        </div>
                                    </div>
                                ) : (
                                    <table className="table mb-0">
                                        <thead className="table-dark-history">
                                            <tr className="bg-table-dark-history-title">
                                                <td className="credit-bl-text text_aff_affiliate"><small>{t(lang, 'date_col')}</small></td>
                                                <td className="credit-bl-text text_aff_affiliate"><small>{t(lang, 'user_label')}</small></td>
                                                <td className="credit-bl-text text_aff_affiliate text-center"><small>{t(lang, 'status_col')}</small></td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {userafftoday.map((item, idx) => (
                                                <tr key={idx} className="bg-table-dark-history">
                                                    <td className="text_aff_affiliate"><small>{item.DateCreate ? item.DateCreate.substring(0, 10) : "-"}</small></td>
                                                    <td className="text_aff_affiliate"><small>{this.maskUsername(item.playerid)}</small></td>
                                                    <td className="text-center">
                                                        {item.checked === 1 ? (
                                                            <span className="badge bg-success"><small>{t(lang, 'deposited_badge')}</small></span>
                                                        ) : (
                                                            <span className="badge bg-secondary"><small>{t(lang, 'not_deposited_badge')}</small></span>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        )}

                        {memberSubTab === 2 && (
                            <div className="bg-profile-box-overview p-2 mb-2 mt-2">
                                <div className="d-flex justify-content-between pb-1">
                                    <small><b>{t(lang, 'history_all_tab')}</b></small>
                                </div>
                                {loading ? (
                                    <div className="text-center p-3">
                                        <span className="text_aff_affiliate">{t(lang, 'loading')}</span>
                                    </div>
                                ) : useradvicelist.length === 0 ? (
                                    <div className="bg-profile-box-overview p-2 text-center animated animatedFadeInUp fadeInUp">
                                        <img
                                            className="load-history"
                                            src="/images/cdn/e4ac87bf-3687-4f37-c96e-6ad9e797bf00.png"
                                            alt=""
                                        />
                                        <div className="not-history font-history-menu-text p-2">
                                            <small><b>{t(lang, 'no_data')}</b></small>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <table className="table mb-0">
                                            <thead className="table-dark-history">
                                                <tr className="bg-table-dark-history-title">
                                                    <td className="credit-bl-text text_aff_affiliate"><small>{t(lang, 'date_col')}</small></td>
                                                    <td className="credit-bl-text text_aff_affiliate"><small>{t(lang, 'user_label')}</small></td>
                                                    <td className="credit-bl-text text_aff_affiliate text-center"><small>{t(lang, 'deposit_type')}</small></td>
                                                    <td className="credit-bl-text text_aff_affiliate text-center"><small>{t(lang, 'withdraw_type')}</small></td>
                                                    <td className="credit-bl-text text_aff_affiliate text-center"><small>{t(lang, 'status_col')}</small></td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {useradvicelist.map((item, idx) => (
                                                    <tr key={idx} className="bg-table-dark-history">
                                                        <td className="text_aff_affiliate"><small>{item.DateCreate ? item.DateCreate.substring(0, 10) : "-"}</small></td>
                                                        <td className="text_aff_affiliate"><small>{this.maskUsername(item.playerid)}</small></td>
                                                        <td className="text_aff_affiliate text-center"><small>{Number(item.total_deposit || 0).toFixed(2)}</small></td>
                                                        <td className="text_aff_affiliate text-center"><small>{Number(item.total_withdraw || 0).toFixed(2)}</small></td>
                                                        <td className="text-center">
                                                            {item.checked === 1 ? (
                                                                <span className="badge bg-success"><small>{t(lang, 'deposited_badge')}</small></span>
                                                            ) : (
                                                                <span className="badge bg-secondary"><small>{t(lang, 'not_deposited_badge')}</small></span>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        {pagecount > 1 && (
                                            <div className="d-flex justify-content-center mt-2">
                                                {Array.from({ length: pagecount }, (_, i) => i + 1).map((pg) => (
                                                    <a
                                                        key={pg}
                                                        role="button"
                                                        className={`btn btn-sm btn-outline-secondary me-1${activePage === pg ? ' active' : ''}`}
                                                        onClick={() => this.handlePageChange(pg)}
                                                    >
                                                        {pg}
                                                    </a>
                                                ))}
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    renderTab3() {
        const lang = this.lang;
        const { timeRange, reports, tblprofile, loading } = this.state;
        const affiliateCash = tblprofile?.AffiliateCash ?? 0;
        return (
            <div className="mb-5 mt-2" style={{ display: this.state.tabselect === 3 ? "" : "none" }}>
                <div className="p-2 bg-profile-box-overview">
                    <div className="animated animatedFadeInUp fadeInUp">
                        <div className="align-self-center">
                            <div className="p-1 text-left">
                                <label>{t(lang, 'income_summary_all')}</label>
                            </div>
                        </div>

                        {/* Filter buttons */}
                        {this.renderFilterButtons(timeRange)}

                        {/* Total income card */}
                        <div className="bg-profile-box-overview p-2 mb-2">
                            <div className="d-flex justify-content-between row m-0 align-items-center">
                                <div className="col-12 col-md-12 p-0">
                                    <div className="d-flex justify-content-between elementor-element-play-overview text-center bg-profile-credit-bl p-2">
                                        <div className="align-self-center">
                                            <div className="p-1 text-left">
                                                <div>
                                                    <small className="text_aff_affiliate">{t(lang, 'network_income_total')}</small>
                                                    <h3 className="m-0">
                                                        <b className="p-1">{Number(reports.thisMonth.totalAmount || 0).toFixed(2)}</b>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="align-self-center text-right">
                                            <div>
                                                <span className="badge text-bg-dark">{reports.percentageChange || "0.00"}%</span>
                                            </div>
                                            <div>
                                                <span className="font-play-text text_aff_affiliate">{t(lang, 'from_last_month')}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Income breakdown */}
                            <div className="row m-0 mt-2">
                                <div className="col-12 col-md-4 p-1">
                                    <div className="elementor-element-play-overview p-2 text-center">
                                        <small className="text_aff_affiliate">{t(lang, 'today_income')}</small>
                                        <div><b>{Number(reports.daily.totalAmount || 0).toFixed(2)}</b></div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4 p-1">
                                    <div className="elementor-element-play-overview p-2 text-center">
                                        <small className="text_aff_affiliate">{t(lang, 'income_this_month')}</small>
                                        <div><b>{Number(reports.thisMonth.totalAmount || 0).toFixed(2)}</b></div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4 p-1">
                                    <div className="elementor-element-play-overview p-2 text-center">
                                        <small className="text_aff_affiliate">{t(lang, 'income_last_month')}</small>
                                        <div><b>{Number(reports.lastMonth.totalAmount || 0).toFixed(2)}</b></div>
                                    </div>
                                </div>
                            </div>

                            {/* Withdraw section */}
                            <div className="pt-2">
                                <div className="row m-0">
                                    <div className="col-12 col-md-12 p-1">
                                        <div className="elementor-element-play-overview p-2">
                                            <div className="d-flex align-items-center mb-2">
                                                <img
                                                    className="logo-profile-user-w p-1"
                                                    src="/images/cdn/48a22d9a-8abe-477f-0f40-57204ce17700.png"
                                                    alt=""
                                                />
                                                <div className="ms-1">
                                                    <small className="text_aff_affiliate">{t(lang, 'withdrawable_income')}</small>
                                                    <div><b className="font-aff-wid" style={{ fontSize: "1.2rem" }}>{affiliateCash}</b> <small className="text_aff_affiliate">{t(lang, 'baht')}</small></div>
                                                </div>
                                            </div>
                                            <a role="button" onClick={(e) => { this.opencliaminvite(e, 'bonusrankaccount'); }} style={{ display: "block" }}>
                                                <div className="btn w-100 p-3" style={{ background: "linear-gradient(135deg,#f6a200,#e67e00)", color: "#fff", fontWeight: "bold", fontSize: "1rem", borderRadius: "8px" }}>
                                                    <img
                                                        className="wid-button p-1"
                                                        src="/images/cdn/de26db72-10a7-4369-5e7e-dd07d4568300.png"
                                                        alt=""
                                                    />
                                                    {t(lang, 'withdraw_btn')}
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderTab4() {
        const lang = this.lang;
        const { linkaff } = this.state;
        return (
            <div className="mb-5 mt-2" style={{ display: this.state.tabselect === 4 ? "" : "none" }}>
                <div className="p-2 bg-profile-box-overview">
                    <div className="animated animatedFadeInUp fadeInUp text-center">
                        <div className="bg-profile-box p-2">
                            <div>
                                <div className="p-2 align-self-center">
                                    <div className="username-profile">
                                        <b>{t(lang, 'aff_easy_rich_tagline')}</b>
                                    </div>
                                    <div className="username-profile">
                                        <b>{t(lang, 'aff_share_link_tagline')}</b>
                                    </div>
                                </div>
                            </div>

                            {/* Step-by-step guide */}
                            <div className="text-left mt-3 p-2">
                                <div className="mb-2 elementor-element-play-overview p-2">
                                    <div className="d-flex align-items-center">
                                        <span className="badge bg-primary me-2">1</span>
                                        <small className="text_aff_affiliate">{t(lang, 'aff_step1')}</small>
                                    </div>
                                </div>
                                <div className="mb-2 elementor-element-play-overview p-2">
                                    <div className="d-flex align-items-center">
                                        <span className="badge bg-primary me-2">2</span>
                                        <small className="text_aff_affiliate">{t(lang, 'aff_step2')}</small>
                                    </div>
                                </div>
                                <div className="mb-2 elementor-element-play-overview p-2">
                                    <div className="d-flex align-items-center">
                                        <span className="badge bg-primary me-2">3</span>
                                        <small className="text_aff_affiliate">{t(lang, 'aff_step3')}</small>
                                    </div>
                                </div>
                                <div className="mb-2 elementor-element-play-overview p-2">
                                    <div className="d-flex align-items-center">
                                        <span className="badge bg-primary me-2">4</span>
                                        <small className="text_aff_affiliate">{t(lang, 'aff_step4')}</small>
                                    </div>
                                </div>
                            </div>

                            {/* Affiliate link copy */}
                            <div className="mt-3 bg-color-financial-my-bank bg-profile-box-overview">
                                <div className="d-flex justify-content-between pt-3 pb-3 px-2">
                                    <div className="align-self-center">
                                        <small>{t(lang, 'your_link')}</small>
                                    </div>
                                    <div className="align-self-center">
                                        <small className="font-play-text text_aff_affiliate">
                                            <small id="copy-ShareLink-tab4">{linkaff}</small>
                                        </small>
                                    </div>
                                    <div className="align-self-center">
                                        <img
                                            role="button"
                                            className="icon-profile-title-left"
                                            src="/images/cdn/270b7b9f-b130-414c-b2a8-dfe9ecb9cc00.png"
                                            alt=""
                                            onClick={() => this.copyLink()}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const lang = this.lang;
        return (
            <>
                <section className="-contact-wrapper row m-0">
                    <div className="-games-provider-wrapper pl-0 pr-0 mx-auto -menu-index-page-bg col-12">
                        {/**/}
                    </div>
                    <div className="-games-index-page col-12">
                        <div className="mb-2 text-white-v1">
                            <div className="d-none d-lg-block"></div>
                            <div className="padding-router-view">
                                <div className="container p-0 x-margin-top-v3">
                                    <div className="row m-0 border-shadow-title">
                                        <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                                            <div className="text-center bg-title-web">
                                                <div>
                                                    <div className="text-title text-white-v1 text-center">
                                                        <div className="d-flex justify-content-between">
                                                            <div className="text-white-v1-deposit">
                                                                <a role="button" href="/">
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width={25}
                                                                        height={25}
                                                                        fill="currentColor"
                                                                        className="bi bi-arrow-left-circle text-white"
                                                                        viewBox="0 0 16 16"
                                                                    >
                                                                        <path
                                                                            fillRule="evenodd"
                                                                            d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                                                                        />
                                                                    </svg>
                                                                </a>
                                                            </div>
                                                            <div className="text-white-v1-deposit">
                                                                <h5>{t(lang, 'affiliate_title')}</h5>
                                                            </div>
                                                            <div>{/**/}</div>
                                                        </div>
                                                        <hr className="mt-0" />
                                                    </div>
                                                </div>

                                                {/* Tab navigation */}
                                                <div>
                                                    <div
                                                        className="d-flex justify-content-between p-1 text-white-v1 bg-refer-title"
                                                        style={{ width: "100%", overflowX: "scroll" }}
                                                    >
                                                        <div className="active-tap-hover">
                                                            <div
                                                                onClick={(e) => { this.checktab(e, 1); }}
                                                                role="button"
                                                                className={this.state.tabselect === 1 ? "text-white-v1 p-1 rounded-pill w-width-tap active-refer" : "text-white-v1 p-1 rounded-pill w-width-tap"}
                                                            >
                                                                <div data-v-ab1d19ba="" className="auction-width">
                                                                    <div data-v-ab1d19ba="" className="auction__body-menu auction__body--border-radius">
                                                                        <div data-v-ab1d19ba="" className="tab text-white-v1">
                                                                            <div data-v-00ef951c="" className="auction-pool-menu text-center">
                                                                                <span className="text-size-menu-casino"><b>{t(lang, 'aff_tab_overview')}</b></span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="active-tap-hover">
                                                            <div
                                                                onClick={(e) => { this.checktab(e, 2); }}
                                                                role="button"
                                                                className={this.state.tabselect === 2 ? "text-white-v1 p-1 rounded-pill w-width-tap active-refer" : "text-white-v1 p-1 rounded-pill w-width-tap"}
                                                            >
                                                                <div data-v-ab1d19ba="" className="auction-width">
                                                                    <div data-v-ab1d19ba="" className="auction__body-menu auction__body--border-radius">
                                                                        <div data-v-ab1d19ba="" className="tab text-white-v1">
                                                                            <div data-v-00ef951c="" className="auction-pool-menu text-center">
                                                                                <span className="text-size-menu-casino"><b>{t(lang, 'aff_tab_members')}</b></span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="active-tap-hover">
                                                            <div
                                                                onClick={(e) => { this.checktab(e, 3); }}
                                                                role="button"
                                                                className={this.state.tabselect === 3 ? "text-white-v1 p-1 rounded-pill w-width-tap active-refer" : "text-white-v1 p-1 rounded-pill w-width-tap"}
                                                            >
                                                                <div data-v-ab1d19ba="" className="auction-width">
                                                                    <div data-v-ab1d19ba="" className="auction__body-menu auction__body--border-radius">
                                                                        <div data-v-ab1d19ba="" className="tab text-white-v1">
                                                                            <div data-v-00ef951c="" className="auction-pool-menu text-center">
                                                                                <span className="text-size-menu-casino"><b>{t(lang, 'aff_tab_income')}</b></span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="active-tap-hover">
                                                            <div
                                                                onClick={(e) => { this.checktab(e, 4); }}
                                                                role="button"
                                                                className={this.state.tabselect === 4 ? "text-white-v1 p-1 rounded-pill w-width-tap active-refer" : "text-white-v1 p-1 rounded-pill w-width-tap"}
                                                            >
                                                                <div data-v-ab1d19ba="" className="auction-width">
                                                                    <div data-v-ab1d19ba="" className="auction__body-menu auction__body--border-radius">
                                                                        <div data-v-ab1d19ba="" className="tab text-white-v1">
                                                                            <div data-v-00ef951c="" className="auction-pool-menu text-center">
                                                                                <span className="text-size-menu-casino"><b>{t(lang, 'aff_tab_network')}</b></span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Tab panels */}
                                            {this.renderTab1()}
                                            {this.renderTab2()}
                                            {this.renderTab3()}
                                            {this.renderTab4()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
    }
}

export default App;
